import ResourcesEditing from './resources-editing';
import { Plugin } from '@ckeditor/ckeditor5-core';
import './styles.css';
class ResourcesUI extends Plugin {
    init() { }
}
export default class Resources extends Plugin {
    static get requires() {
        return [ResourcesEditing, ResourcesUI];
    }
}
